import IranIcon from '@/common/assets/icons/iranIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { FreeZonePlateType } from '@/common/types/Plate.type';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';

const MotorCyclePlateShow = ({
  plateData,
}: {
  plateData: FreeZonePlateType;
}) => {
  return (
    <Flex
      className={css({
        flexDirection: 'row-reverse',
        alignItems: 'center',
      })}
    >
      <Box
        className={css({
          bg: '#0042AD',
          borderLeftRadius: '4px',
          borderRight: 'none',
          width: '12px',
          height: '24px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        })}
      >
        <IranIcon
          className={css({
            width: '7px',
          })}
        />
      </Box>
      <Box
        className={css({
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          pr: '2px',
          gap: '3px',
          border: '1px solid',
          height: '24px',
        })}
      >
        <Typography fontSize={'11px'} textStyle={'b3'}>
          {plateData.vehicle_plate_top}
        </Typography>
      </Box>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          height: '24px',
          alignItems: 'center',
          position: 'relative',
          px: '3px',
          border: '1px solid',
          borderLeft: 'none',
          borderRightRadius: '4px',
        }}
      >
        <Typography top={'-20px'} fontSize={'11px'} textStyle={'b3'}>
          {plateData.vehicle_plate_bottom}
        </Typography>
      </Box>
    </Flex>
  );
};

export default MotorCyclePlateShow;
